import { Component } from '@opten/compiler/metadata/component';
import {MapExtended} from '../../../Opten.HypothekarbankLenzburg.Core.Static/components/map-extended/map-extended';
declare var Cookiebot;

@Component({ className: 'js-map-extended' })
export class MapExtendedComponent {
    private mapExtended: MapExtended;

	constructor(private element: HTMLElement) {
		if(typeof(Cookiebot) !== 'undefined'){
			window.addEventListener('CookiebotOnAccept', () => {
				if(Cookiebot.consent.marketing && (this.mapExtended == undefined || this.mapExtended == null)){
					this.initMap(this.element);
				}
			});
		}
		else{
			this.initMap(this.element);
		}
	}

	private initMap(element: HTMLElement){
        const showMapMarkerClasses = element.getAttribute(
			'data-show-marker-classes'
		);
		const showMapMarkerClassesList =
			showMapMarkerClasses.length > 0
				? showMapMarkerClasses.split(',')
				: [];
		const mapMarkerInformations = Array.from(
			element.getElementsByClassName('c-map-extended__information')
		);
		let mapMarkerClasses = [];
		if (mapMarkerInformations != null) {
			mapMarkerInformations.forEach(e => {
				mapMarkerClasses.push(e.getAttribute('data-marker-class'));
			});
			mapMarkerClasses = mapMarkerClasses.filter(
				(v, i, a) => a.indexOf(v) === i
			);
		}
		const mapStylesAll = this.getMapStyles();
		this.mapExtended = new MapExtended(element, {
			showMapMarkerClasses: showMapMarkerClassesList,
			mapMarkerClasses: mapMarkerClasses,
			mapStyles: mapStylesAll,
			hasMapMarkerClassesButtonIfMultiple: true,
			styledMapName: 'Hypi'
		});
    }

    private getMapStyles(){
        return [
			{
				featureType: 'administrative',
				elementType: 'labels.text.fill',
				stylers: [
					{
						color: '#000000'
					}
				]
			},
			{
				featureType: 'administrative.country',
				elementType: 'geometry.fill',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'landscape',
				stylers: [
					{
						color: '#eaeaea'
					}
				]
			},
			{
				featureType: 'poi',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road',
				stylers: [
					{
						saturation: -100
					},
					{
						lightness: 45
					}
				]
			},
			{
				featureType: 'road',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#ffffff'
					}
				]
			},
			{
				featureType: 'road.arterial',
				elementType: 'labels.icon',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'road.highway',
				stylers: [
					{
						visibility: 'simplified'
					}
				]
			},
			{
				featureType: 'transit',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'water',
				stylers: [
					{
						color: '#007dc0'
					},
					{
						visibility: 'on'
					}
				]
			},
			{
				featureType: 'water',
				elementType: 'geometry.fill',
				stylers: [
					{
						color: '#007dc0'
					},
					{
						gamma: 1
					},
					{
						visibility: 'on'
					}
				]
			},
			{
				featureType: 'water',
				elementType: 'geometry.stroke',
				stylers: [
					{
						visibility: 'off'
					}
				]
			},
			{
				featureType: 'water',
				elementType: 'labels.text',
				stylers: [
					{
						visibility: 'off'
					}
				]
			}
		];
    }
}